module.exports = __webpack_public_path__ + "img/dragon-right.3e37e085.png";